// Customize this 'myform.js' script and add it to your JS bundle.
// Then import it with 'import MyForm from "./myform.js"'.
// Finally, add a <MyForm/> element whereever you wish to display the form.

import React from "react"

export default class EmailCollection extends React.Component {
  constructor(props) {
    super(props)
    this.submitForm = this.submitForm.bind(this)
    this.state = {
      status: "",
    }
  }

  render() {
    const { status } = this.state
    return (
      <form
        onSubmit={this.submitForm}
        action="https://formspree.io/mzbjwwbv"
        method="POST"
        class="button-container"
      >
        {/* <!-- add your custom form HTML here --> */}

        {status === "SUCCESS" ? (
          <p style={{ paddingTop: "70px" }}>Thanks!</p>
        ) : (
          <>
            <input type="email" name="email" class="form" />
            <button class="styled-button">Submit</button>
            <p style={{ paddingTop: "20px" }}>
              Sign up to be the first to know about any updates. We promise to
              never spam you.
            </p>
          </>
        )}
        {status === "ERROR" && <p style={{ paddingTop: "20px" }}>Try Again?</p>}
      </form>
    )
  }

  submitForm(ev) {
    ev.preventDefault()
    const form = ev.target
    const data = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action)
    xhr.setRequestHeader("Accept", "application/json")
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return
      if (xhr.status === 200) {
        form.reset()
        this.setState({ status: "SUCCESS" })
      } else {
        this.setState({ status: "ERROR" })
      }
    }
    xhr.send(data)
  }
}
